module.exports = __webpack_public_path__ + "img/box.76a5bca6.png";